import {createApi} from "@reduxjs/toolkit/query/react";
import {Response} from "../../types/response/Response";
import {apiQueryV1} from "../utils/Extensions";
import {OrderProductDTO} from "../../types/order/OrderProductDTO";
import {
    ValidateOriginalSignRequestDTO,
    ValidateOriginalSignResponseDTO
} from "../../types/order/ValidateOriginalSignDTO";
import {ProductMarkSaveDTO} from "../../types/order/ProductMarkSaveDTO";


export const productApi = createApi({
    reducerPath: "product",
    baseQuery: apiQueryV1,
    tagTypes: ["productList"],
    endpoints: builder => ({
        getOrderProductList: builder.query<OrderProductDTO[] | null, Partial<number>>({
            query: (orderId) => `/deliveries/${orderId}/products`,
            providesTags: ["productList"],
            extraOptions: {maxRetries: 3},
            transformResponse: (response: Response<OrderProductDTO[]>) => {
                if (!response?.data) {
                    return null
                }
                return response
                    ?.data
                    ?.filter(it => !!it)
                    ?.sort((a, b) => b.mustBeScanned ? 1 : 0 - (a.mustBeScanned ? 1 : 0))
            }
        }),
        validateOriginalSign: builder.mutation<ValidateOriginalSignResponseDTO, Partial<ValidateOriginalSignRequestDTO>>({
            query: (data) => ({
                url: "/deliveries/check-fiscal",
                method: "POST",
                body: data
            }),
            extraOptions: {maxRetries: 3}
        }),
        saveProductMarking: builder.mutation<void, Partial<ProductMarkSaveDTO>>({
            query: (data) => ({
                url: `/deliveries/${data.orderId}/products`,
                method: "POST",
                body: data.productList
            }),
            invalidatesTags: ["productList"]
        })
    })
})

export const {
    useGetOrderProductListQuery,
    useValidateOriginalSignMutation,
    useSaveProductMarkingMutation
} = productApi
